/* ============================================================================
   LAH — APOIO NO FLUXO MULTIFOCAL
   Tema: Testes de implementacao (2.0)

   O QUE FAZ
   1. Detecta se o cliente entrou pelo caminho MULTIFOCAL.
   2. Marca as etapas desse caminho com .is-multifocal.
   3. Injeta um bloco de apoio por WhatsApp nas etapas do caminho.
   4. Monta a mensagem com CONTEXTO: modelo, cor e etapa atual.

   ============================================================================
   O LACO QUE TRAVAVA A TROCA DE ETAPA
   ============================================================================
   Sintoma: em alguns aparelhos, ao escolher multifocal a proxima etapa nao
   aparecia — o fluxo simplesmente parava.

   Causa: o observador vigiava mudancas de class e style dentro do
   configurador e chamava aplicar(). Mas aplicar() TAMBEM mexe em class e
   style (marca as etapas, mostra e esconde o botao antigo). Cada passada
   disparava a proxima, quadro after quadro, sem parar.

   O agendamento por requestAnimationFrame evitava a recursao imediata, entao
   nada estourava — o laco apenas rodava para sempre, consumindo a linha
   principal. Em aparelho rapido, invisivel; em aparelho lento, a transicao do
   Alpine nao conseguia espaco para rodar e a etapa nunca aparecia.

   Isso tambem explica por que o bug era intermitente e dificil de reproduzir:
   ele dependia da velocidade do aparelho e de quantos outros scripts
   disputavam a mesma linha.

   DUAS CORRECOES, e as duas sao necessarias:

     1. O OBSERVADOR SE DESLIGA enquanto aplicar() roda, e volta depois que as
        mutacoes dele foram entregues. Sem isso, as proprias mudancas de
        aplicar() reiniciam o ciclo.

     2. SO ESCREVEMOS QUANDO O VALOR MUDA. Mesmo desligado o observador, um
        classList.toggle ou um style.display com o mesmo valor de antes conta
        como escrita para o navegador e gera trabalho de layout a toa — dezenas
        de vezes por segundo, em dezenas de etapas.

   A segunda correcao sozinha ja quase resolveria, mas "quase" aqui significa
   voltar a falhar no aparelho mais lento que aparecer.

   ============================================================================
   ETAPAS COMPARTILHADAS
   ============================================================================
   "Selecione o tratamento" e a MESMA etapa para monofocal e multifocal: o
   configurador reaproveita o bloco, so muda o caminho que leva ate ele. Por
   isso nao da para decidir pelo handle da etapa — e preciso saber por ONDE o
   cliente entrou.

   O estado e derivado da escolha na PRIMEIRA etapa (tipo de lente), e
   aplicar() tanto adiciona quanto remove — sempre refletindo o estado atual,
   nunca o acumulado.
   ============================================================================ */

(function () {
    'use strict';

    var NUMERO = '5522981436010';

    /* Exclusivas do caminho multifocal: o apoio vale sempre nelas. */
    var ETAPAS_MULTI = ['campo-de-visao', 'espessura-de-suas-lentes-multifocais'];

    /* Compartilhadas com monofocal: so valem se o cliente entrou por
       multifocal na primeira etapa. */
    var ETAPAS_COMPARTILHADAS = ['tratamento'];

    /* Handle da etapa que define o caminho */
    var ETAPA_TIPO = 'tipo-de-lente';

    var root = document.querySelector('.product-lens-select');
    if (!root) return;

    var escolheuMultifocal = false;
    var observer = null;
    var aplicando = false;

    function normalize(text) {
        return (text || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function contextoProduto() {
        var nome = root.querySelector('.product-lens-name');
        var cor = root.querySelector('.product-lens-model');
        return {
            nome: nome ? nome.textContent.trim() : '',
            cor: cor ? cor.textContent.trim() : ''
        };
    }

    function tituloDaEtapa(step) {
        var t = step.querySelector('.product-lens-step-title');
        return t ? t.textContent.trim() : '';
    }

    function montarMensagem(step) {
        var ctx = contextoProduto();
        var etapa = tituloDaEtapa(step);

        var partes = ['Olá! Estou montando meu óculos multifocal no site'];

        if (ctx.nome) {
            var produto = ctx.nome;
            if (ctx.cor) produto += ' (' + ctx.cor + ')';
            partes.push('Modelo: ' + produto);
        }

        if (etapa) {
            partes.push('Estou na etapa: ' + etapa);
        }

        partes.push('Pode me ajudar a escolher?');

        return partes.join('. ');
    }

    function criarBloco(step) {
        if (step.querySelector('.lah-mf-help')) return;

        var link = document.createElement('a');
        link.className = 'lah-mf-help';
        link.target = '_blank';
        link.rel = 'noopener';

        link.innerHTML =
            '<span class="lah-mf-help__icon">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
            '<path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.4A10 10 0 1 0 12 2Zm5.5 14.1c-.2.6-1.2 1.2-1.7 1.2-.5.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.6a11 11 0 0 1-4.2-3.8c-.6-.8-1-1.7-1-2.6 0-1 .5-1.5.7-1.7.2-.2.5-.3.6-.3h.5c.2 0 .4 0 .6.4l.7 1.7c.1.2 0 .4-.1.5l-.3.4c-.1.1-.3.3-.1.5.3.5.7 1 1.2 1.5.6.5 1.1.7 1.4.9.2.1.4.1.5-.1l.6-.7c.2-.2.3-.1.5-.1l1.6.8c.2.1.4.2.4.3.1.2.1.7-.1 1.3Z"/>' +
            '</svg></span>' +
            '<span class="lah-mf-help__text">' +
            '<span class="lah-mf-help__title">Ficou em dúvida? Fale com a gente</span>' +
            '<span class="lah-mf-help__sub">Ajudaremos você a escolher, pelo WhatsApp</span>' +
            '</span>' +
            '<span class="lah-mf-help__arrow">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M9 6l6 6-6 6"/></svg></span>';

        /* O href e montado no CLIQUE: a etapa e a cor podem ter mudado desde
           que o bloco foi inserido. */
        link.addEventListener('click', function () {
            link.href = 'https://wa.me/' + NUMERO + '?text=' +
                encodeURIComponent(montarMensagem(step));

            track('lens_multifocal_suporte', { etapa: tituloDaEtapa(step) });
        });

        step.appendChild(link);
    }

    function removerBloco(step) {
        var bloco = step.querySelector('.lah-mf-help');
        if (bloco) bloco.remove();
    }

    function contemAlgum(seletor, lista) {
        for (var i = 0; i < lista.length; i++) {
            if (seletor.indexOf(lista[i]) !== -1) return true;
        }
        return false;
    }

    function ehEtapaMulti(step) {
        var seletor = step.getAttribute('data-step-selector') || '';

        if (contemAlgum(seletor, ETAPAS_MULTI)) return true;

        /* Compartilhadas dependem do caminho de entrada */
        if (escolheuMultifocal && contemAlgum(seletor, ETAPAS_COMPARTILHADAS)) {
            return true;
        }

        return false;
    }

    /* Aplica E REMOVE: o estado da tela sempre reflete o caminho atual, nunca
       o acumulado de escolhas anteriores.

       Cada escrita e condicional — ver a nota sobre o laco no topo. */
    function aplicar() {
        if (aplicando) return;
        aplicando = true;

        if (observer) observer.disconnect();

        var steps = root.querySelectorAll('.product-lens-select-step');

        Array.prototype.forEach.call(steps, function (step) {
            var deveTer = ehEtapaMulti(step);
            var tem = step.classList.contains('is-multifocal');

            if (deveTer !== tem) {
                step.classList.toggle('is-multifocal', deveTer);
            }

            var bloco = step.querySelector('.lah-mf-help');

            if (deveTer && !bloco) {
                criarBloco(step);
            } else if (!deveTer && bloco) {
                removerBloco(step);
            }

            /* O botao do metaobject some apenas onde o nosso bloco existe */
            var antigo = step.querySelector('.step_whats_button');
            if (antigo) {
                var desejado = deveTer ? 'none' : '';
                if (antigo.style.display !== desejado) {
                    antigo.style.display = desejado;
                }
            }
        });

        /* Religamos SO no proximo quadro: as mutacoes feitas agora ja foram
           entregues, e o observador volta sem receber as proprias mudancas. */
        requestAnimationFrame(function () {
            aplicando = false;
            ligarObserver();
        });
    }

    /* ---- O caminho e definido na PRIMEIRA etapa ----
       Derivamos o estado da escolha feita ali, em vez de so ligar quando ve a
       palavra "multifocal": assim escolher "Com Grau" DESLIGA o modo, e voltar
       atras para trocar de caminho funciona como o cliente espera. */
    document.addEventListener('click', function (event) {
        var item = event.target.closest ? event.target.closest('.product-lens-select-item') : null;
        if (!item) return;

        var step = item.closest('.product-lens-select-step');
        if (!step) return;

        var seletor = step.getAttribute('data-step-selector') || '';
        if (seletor.indexOf(ETAPA_TIPO) === -1) return;

        escolheuMultifocal =
            normalize(item.getAttribute('data-item-name')).indexOf('multifocal') !== -1;

        /* Proximo quadro: o Alpine ja trocou a etapa visivel */
        requestAnimationFrame(aplicar);
    }, true);

    /* Reabrir o configurador comeca um pedido novo: o caminho volta a ser
       indefinido ate a primeira escolha. */
    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('.openProductLens')) {
            escolheuMultifocal = false;
            requestAnimationFrame(aplicar);
        }
    });

    /* =====================================================================
       OBSERVADOR

       Existe porque o Alpine monta as etapas sob demanda: uma etapa que ainda
       nao foi renderizada nao pode ser marcada de antemao.

       Nao observa mais ATRIBUTOS, so a entrada e saida de elementos. Antes
       vigiava class e style — exatamente o que aplicar() escreve — e cada
       passada alimentava a proxima. Para saber que uma etapa nova existe,
       childList basta.
       ===================================================================== */
    function ligarObserver() {
        if (!window.MutationObserver) return;

        if (!observer) {
            var pendente = false;

            observer = new MutationObserver(function () {
                if (pendente || aplicando) return;
                pendente = true;

                requestAnimationFrame(function () {
                    pendente = false;
                    aplicar();
                });
            });
        }

        observer.observe(root, { childList: true, subtree: true });
    }

    aplicar();
})();
